"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var inertia_react_1 = require("@inertiajs/inertia-react");
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var react_i18next_1 = require("react-i18next");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var AccountSettingsForm_module_css_1 = __importDefault(require("./AccountSettingsForm.module.css"));
var react_country_region_selector_1 = require("react-country-region-selector");
var AccountSettingsFormItem_1 = __importDefault(require("./AccountSettingsFormItem"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var AccountSettingsForm = function () {
    var defaultErrors = { fullName: "", companyVat: "", addressLine: "", postalCode: "", city: "" };
    var defaultProps = { disabled: false, saved: false, text: "" };
    var defaultUsers = [];
    var page = (0, useTypedPage_1.default)();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(defaultProps), props = _a[0], setProps = _a[1];
    var _b = (0, react_1.useState)(defaultErrors), errors = _b[0], setErrors = _b[1];
    var logger = q_play_core_1.logManager.getLogger();
    var form = (0, inertia_react_1.useForm)({
        fullName: "",
        companyVat: "",
        addressLine: "",
        postalCode: "",
        city: "",
        country: "",
        contactUser: "",
        upodiId: "",
        isDeveloper: false,
        defaultAppAccess: true,
        advancedSso: false,
    });
    var _c = (0, react_1.useState)(defaultUsers), users = _c[0], setUsers = _c[1];
    var validation = function (errors) {
        var checkValidation = 0;
        Object.values(errors).forEach(function (val) {
            if (val.length > 0) {
                checkValidation += 1;
            }
        });
        return checkValidation;
    };
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var account, usersResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.getAccountByAccountId(page.props.session.current_account.id)];
                    case 1:
                        account = _a.sent();
                        return [4 /*yield*/, ApiManager_1.default.getUsersForAccountByAccountId(page.props.session.current_account.id)];
                    case 2:
                        usersResponse = _a.sent();
                        form.setData({
                            fullName: account.name ? account.name : "",
                            companyVat: account.company_vat ? account.company_vat : "",
                            addressLine: account.address_line ? account.address_line : "",
                            postalCode: account.postal_code ? account.postal_code : "",
                            city: account.city ? account.city : "",
                            country: account.country ? account.country : "Denmark",
                            contactUser: account.contact_user ? account.contact_user : usersResponse[0].id,
                            upodiId: account.upodi_id,
                            isDeveloper: account.is_developer ? account.is_developer : false,
                            defaultAppAccess: account.default_app_access ? account.default_app_access : true,
                            advancedSso: account.advanced_sso ? account.advanced_sso : false,
                        });
                        setUsers(usersResponse);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    (0, react_1.useEffect)(function () {
        if (validation(errors)) {
            setProps({ disabled: true });
        }
        else {
            setProps({ disabled: false });
        }
    }, [errors]);
    var onSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var newAccount, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!!validation(errors)) return [3 /*break*/, 3];
                    newAccount = {
                        id: page.props.session.current_account.id,
                        name: form.data.fullName,
                        company_vat: form.data.companyVat,
                        address_line: form.data.addressLine,
                        postal_code: form.data.postalCode,
                        city: form.data.city,
                        country: form.data.country,
                        contact_user: parseInt(form.data.contactUser),
                        upodi_id: form.data.upodiId,
                        default_app_access: form.data.defaultAppAccess,
                        is_developer: form.data.isDeveloper,
                        advanced_sso: form.data.advancedSso,
                    };
                    setProps({ disabled: true });
                    return [4 /*yield*/, ApiManager_1.default.updateAccountInDatabase(newAccount.id, newAccount)];
                case 2:
                    response = _a.sent();
                    if (response.message) {
                        setProps({ saved: true, disabled: false, text: response.message });
                        setTimeout(function () {
                            setProps({ saved: false });
                        }, 5000);
                    }
                    else {
                        setProps({ saved: true, disabled: false, text: response });
                        setTimeout(function () {
                            setProps({ saved: false });
                        }, 3000);
                    }
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    logger.error("Saving changes to an account failed. Exception: ", e_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var inputValidation = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, id, value;
        return __generator(this, function (_b) {
            event.preventDefault();
            _a = event.target, id = _a.id, value = _a.value;
            switch (id) {
                case "fullName":
                    setErrors({
                        fullName: value.length > 100 ? t("Company name cannot be longer than 100 characters") : "",
                        companyVat: errors.companyVat, addressLine: errors.addressLine, postalCode: errors.postalCode, city: errors.city
                    });
                    break;
                case "companyVat":
                    setErrors({
                        companyVat: value.length > 20 ? t("VAT ID cannot be longer than 10 characters") : "",
                        fullName: errors.fullName, addressLine: errors.addressLine, postalCode: errors.postalCode, city: errors.city
                    });
                    break;
                case "addressLine":
                    setErrors({
                        addressLine: value.length > 100 ? t("Address cannot be longer than 100 characters") : "",
                        fullName: errors.fullName, companyVat: errors.companyVat, postalCode: errors.postalCode, city: errors.city
                    });
                    break;
                case "postalCode":
                    setErrors({
                        postalCode: value.length > 10 ? t("Zip Code cannot be longer than 10 digits") : "",
                        fullName: errors.fullName, companyVat: errors.companyVat, addressLine: errors.addressLine, city: errors.city
                    });
                    break;
                case "city":
                    setErrors({
                        city: value.length > 60 ? t("City cannot be longer than 60 characters") : "",
                        fullName: errors.fullName, companyVat: errors.companyVat, addressLine: errors.addressLine, postalCode: errors.postalCode
                    });
                    break;
                default:
                    break;
            }
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement("form", { onSubmit: onSubmit },
        react_1.default.createElement("div", { id: AccountSettingsForm_module_css_1.default.formContainer },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-sm-6" },
                    react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.title },
                        react_1.default.createElement("span", null, t("Organization"))),
                    react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                            {
                                permission: "edit-account",
                                children: (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("Organization"), id: "fullName", type: "text", value: form.data.fullName, className: form.data.fullName.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: true, onChange: function (e) { inputValidation(e); form.setData("fullName", e.currentTarget.value); }, error: errors.fullName, dataCy: "accountSettingsName" }),
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("VAT ID"), id: "companyVat", type: "text", value: form.data.companyVat, className: form.data.companyVat.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: false, onChange: function (e) { inputValidation(e); form.setData("companyVat", e.currentTarget.value); }, error: errors.companyVat, dataCy: "accountSettingsVat" }),
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("Address"), id: "addressLine", type: "text", value: form.data.addressLine, className: form.data.addressLine.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: false, onChange: function (e) { inputValidation(e); form.setData("addressLine", e.currentTarget.value); }, error: errors.addressLine, dataCy: "accountSettingsAddress" }),
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("Zip Code"), id: "postalCode", type: "text", value: form.data.postalCode, className: form.data.postalCode.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: false, onChange: function (e) { inputValidation(e); form.setData("postalCode", e.currentTarget.value); }, error: errors.postalCode, dataCy: "accountSettingsPostalCode" }),
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("City"), id: "city", type: "text", value: form.data.city, className: form.data.city.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: false, onChange: function (e) { inputValidation(e); form.setData("city", e.currentTarget.value); }, error: errors.city, dataCy: "accountSettingsCity" }),
                                    react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputContainer },
                                        react_1.default.createElement(Label_1.default, { htmlFor: "country", className: AccountSettingsForm_module_css_1.default.label }, t("Country")),
                                        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputFieldContainer },
                                            react_1.default.createElement(react_country_region_selector_1.CountryDropdown, { classes: AccountSettingsForm_module_css_1.default.inputField, value: form.data.country, onChange: function (val) { form.setData("country", val), form.data.country = val; }, defaultOptionLabel: "" })))))
                            },
                            {
                                permission: "see-account-settings",
                                children: (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("Organization"), id: "fullName", type: "text", value: form.data.fullName, className: form.data.fullName.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: true, error: errors.fullName, style: { cursor: "default" }, disabled: true, dataCy: "accountSettingsName" }),
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("VAT ID"), id: "companyVat", type: "text", value: form.data.companyVat, className: form.data.companyVat.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: false, error: errors.companyVat, style: { cursor: "default" }, disabled: true, dataCy: "accountSettingsVat" }),
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("Address"), id: "addressLine", type: "text", value: form.data.addressLine, className: form.data.addressLine.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: false, error: errors.addressLine, style: { cursor: "default" }, disabled: true, dataCy: "accountSettingsAddress" }),
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("Zip Code"), id: "postalCode", type: "text", value: form.data.postalCode, className: form.data.postalCode.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: false, error: errors.postalCode, disabled: true, style: { cursor: "default" }, dataCy: "accountSettingsPostalCode" }),
                                    react_1.default.createElement(AccountSettingsFormItem_1.default, { text: t("City"), id: "city", type: "text", value: form.data.city, className: form.data.city.length > 0 ? "is-invalid ".concat(AccountSettingsForm_module_css_1.default.inputField) : AccountSettingsForm_module_css_1.default.inputField, required: false, error: errors.city, disabled: true, style: { cursor: "default" }, dataCy: "accountSettingsCity" }),
                                    react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputContainer },
                                        react_1.default.createElement(Label_1.default, { htmlFor: "country", className: AccountSettingsForm_module_css_1.default.label }, t("Country")),
                                        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputFieldContainer },
                                            react_1.default.createElement(react_country_region_selector_1.CountryDropdown, { classes: AccountSettingsForm_module_css_1.default.inputField, value: form.data.country, onChange: function (e) { return (e); }, defaultOptionLabel: "", disabled: true })))))
                            }
                        ] })),
                react_1.default.createElement("div", { className: "col-sm-6" },
                    react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.title },
                        react_1.default.createElement("span", null, t("Contact Person"))),
                    react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputContainer },
                        react_1.default.createElement(Label_1.default, { htmlFor: "contactFullName", className: AccountSettingsForm_module_css_1.default.label }, t("Contact Person - Name")),
                        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputFieldContainer },
                            react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                                    {
                                        permission: "edit-account",
                                        children: (react_1.default.createElement("select", { value: form.data.contactUser, className: AccountSettingsForm_module_css_1.default.inputField, onChange: function (e) {
                                                form.setData("contactUser", e.currentTarget.value);
                                            } }, users.map(function (user) { return (react_1.default.createElement("option", { value: user.id, key: user.id }, user.name)); })))
                                    },
                                    {
                                        permission: "see-account-settings",
                                        children: (react_1.default.createElement("select", { value: form.data.contactUser, className: AccountSettingsForm_module_css_1.default.inputField, disabled: true }, users.map(function (user) { return (react_1.default.createElement("option", { value: user.id, key: user.id }, user.name)); })))
                                    }
                                ] }))),
                    react_1.default.createElement(AccessControl_1.default, { requiredPermissions: "sys-admin" },
                        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.title },
                            react_1.default.createElement("span", null, t("Account settings (Admin)"))),
                        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputFieldContainer },
                            react_1.default.createElement(q_play_components_1.SettingsComponent, { value: form.data.defaultAppAccess, setting: q_play_core_1.Setting.createSettingFromData("defaultAppAccess", { type: "boolean", label: "Default app access", layout: "full" }), onChange: function (event) { return form.setData("defaultAppAccess", event.target.checked); }, disabled: false })),
                        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputFieldContainer, style: { width: "75%" } },
                            react_1.default.createElement(q_play_components_1.SettingsComponent, { value: form.data.isDeveloper, setting: q_play_core_1.Setting.createSettingFromData("defaultAppAccess", { type: "boolean", label: "is developer", layout: "full" }), onChange: function (event) { return form.setData("isDeveloper", event.target.checked); }, disabled: false })),
                        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputFieldContainer, style: { width: "75%" } },
                            react_1.default.createElement(q_play_components_1.SettingsComponent, { value: form.data.advancedSso, setting: q_play_core_1.Setting.createSettingFromData("advancedSSO", { type: "boolean", label: "Advanced SSO", layout: "full" }), onChange: function (event) { return form.setData("advancedSso", event.target.checked); }, disabled: false })))))),
        react_1.default.createElement("div", { id: AccountSettingsForm_module_css_1.default.buttonContainer },
            react_1.default.createElement("div", { style: { display: "flex" } },
                props.saved ? react_1.default.createElement("span", { style: { fontFamily: "Geomanist", margin: "auto 1rem" } }, t(props.text)) : null,
                react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                        {
                            permission: "edit-account",
                            children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), isDisabled: props.disabled, dataCy: "saveAccountButton" }))
                        },
                        {
                            permission: "see-account-settings",
                            children: (react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), isDisabled: true, dataCy: "saveAccountButton" }))
                        }
                    ] })))));
};
exports.default = AccountSettingsForm;
